export const getAllShipments = (state) => {
  return state.shipments;
}
export const getShipmentById = (state) => {
  return shipmentId => state.shipments[shipmentId];
}

export const getMultipleShipmentsCounter = (state) => {
  return state.multipleShipmentsCounter;
}
